import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex align-items-center justify-content-center",
  style: {"height":"100vh","background":"#020c1b"}
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

import Main from "@/layout/main.vue";
import {onMounted, ref} from "vue";
import GridLoader from "@/components/Animation/GridLoader.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const showMainContent = ref(false)
const loaderVisible = ref(true);
// onMounted(() => {
//     setTimeout(() => {
//         loaderVisible.value = false;
//         setTimeout(() => {
//             showMainContent.value = true;
//         }, 500)
//     }, 1000)
//
// })
window.onload=function (){
    console.log('loading resource finished')
    setTimeout(() => {
        loaderVisible.value = false;
        setTimeout(() => {
            showMainContent.value = true;
        }, 500)
    }, 1000)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!showMainContent.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_Transition, { name: "bounce" }, {
            default: _withCtx(() => [
              (loaderVisible.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(GridLoader, { color: '#64FFDA' })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (showMainContent.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(Main)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})